"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TopicViewsCountAction = exports.TopicViewsCount = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Eye = _interopRequireDefault(require("@insided/destination/icons/Eye"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _excluded = ["className", "children"];

var TopicViewsCount = function TopicViewsCount(_ref) {
  var views = _ref.views;
  return (0, _preact.h)("span", {
    className: "topic__views-count",
    "aria-label": "".concat(views, " views")
  }, (0, _preact.h)(_Eye.default, {
    role: "presentation",
    className: (0, _classnames.default)('thread-meta-item__icon icon--auto-width', 'icon--eye'),
    width: 20,
    height: 20
  }), (0, _preact.h)(_phrase.default, {
    p: "accessibility_label.current_views",
    renderAsText: true
  }, function (accessibilityLabel) {
    return (0, _preact.h)("span", {
      className: "thread-meta-item__text",
      "aria-label": accessibilityLabel
    }, views);
  }));
};

exports.TopicViewsCount = TopicViewsCount;

var TopicViewsCountAction = function TopicViewsCountAction(_ref2) {
  var className = _ref2.className,
      children = _ref2.children,
      anchorProps = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  return (0, _preact.h)(_phrase.default, {
    p: "accessibility_label.view_topic",
    renderAsText: true
  }, function (accessibilityLabel) {
    return (0, _preact.h)("a", (0, _extends2.default)({
      className: (0, _classnames.default)('qa-topic-meta-views', className)
    }, anchorProps, {
      "aria-label": accessibilityLabel
    }), children);
  });
};

exports.TopicViewsCountAction = TopicViewsCountAction;
var _default = TopicViewsCount;
exports.default = _default;